export enum NotificationType {
    WARNING = 1,
    ALERT = 2,
    INFO = 3,
}
